<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <p><strong>First Name: </strong>{{ user.firstname }}</p>
        <p><strong>Last Name: </strong>{{ user.lastname }}</p>
        <p><strong>E-mail: </strong>{{ user.email }}</p>
      </div>
    </div>
    <br/>
    <div class="row">
      <h4>User vehicles</h4>
      <table class="table">
        <thead>
        <th scope="col">Display name</th>
        <th scope="col">Year</th>
        <th scope="col">Created at</th>
        <th scope="col">Updated at</th>
        <th scope="col">Active</th>
        <th scope="col">More details:</th>
        </thead>
        <tbody>
        <tr v-for="row in vehicles">
          <td>{{ row.displayName }}</td>
          <td>{{ row.year }}</td>
          <td>{{ row.createdAt }}</td>
          <td>{{ row.updatedAt }}</td>
          <td>{{ row.active }}</td>
          <td><a :href="'/admin/vehicles/' + row.id" target="_blank">More details</a></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { apiClient } from '../../helpers/api-client';
import { HTTP_METHODS, HTTP_STATUS_CODES } from '../../helpers/config';

export default {
  name: 'UserView',
  setup() {

  },
  data() {
    return {
      user: {},
      vehicles: []
    }
  },
  async created() {
    await this.loadUser(this.$route.params.id);
    await this.loadVehicles(this.$route.params.id);
  },
  methods: {
    loadUser: async function (userid) {
      const result = await apiClient(`users/${userid}`, HTTP_METHODS.GET);
      if (result.status === HTTP_STATUS_CODES.SUCCESS) {
        this.user = result.data;
      }
    },
    loadVehicles: async function (userid) {
      const result = await apiClient(`users/${userid}/ownedVehicles`, HTTP_METHODS.GET);
      if (result.status === HTTP_STATUS_CODES.SUCCESS) {
        this.vehicles = result.data;
      }
    }
  }
}
</script>
